import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { X } from "lucide-react";
import ProductRowFields from "./ProductRowFields";
import SaleRowFields from "./SaleRowFields";

export default function RowCard({ row, onChange, onRemove, isProduct, products, index, photoIndex, intraScanLink }) {
  return (
    <div
      data-testid={`receipt-row-${index}`}
      className={`rounded-xl border p-4 transition-all ${
        row.__saved
          ? "border-[#C5E1D1] bg-[#F0F7F2] opacity-90"
          : row.__selected
          ? "border-[#2E4A3B] bg-white"
          : "border-[#EAE7E1] bg-[#F9F8F6] opacity-60"
      }`}
    >
      <div className="flex items-start justify-between gap-3 mb-3">
        <div className="flex items-start gap-3 min-w-0 flex-1">
          <Checkbox
            data-testid={`receipt-row-check-${index}`}
            checked={row.__selected}
            onCheckedChange={(v) => onChange({ __selected: !!v })}
            disabled={row.__saved}
            className="mt-1 data-[state=checked]:bg-[#2E4A3B] data-[state=checked]:border-[#2E4A3B]"
          />
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2 mb-1 flex-wrap">
              <span className="text-[10px] font-mono font-semibold text-[#2E4A3B] bg-[#E8F3EC] border border-[#C5E1D1] h-5 px-1.5 rounded flex items-center">
                #{index + 1}
              </span>
              {row.__saved && (
                <span
                  data-testid={`receipt-row-saved-${index}`}
                  className="text-[10px] font-semibold text-[#2B5A3F] bg-[#DFF0E4] border border-[#B4D8BF] h-5 px-1.5 rounded inline-flex items-center gap-1"
                >
                  ✓ Registrata
                </span>
              )}
              {photoIndex !== undefined && photoIndex !== null && (
                <span
                  data-testid={`receipt-row-photo-${index}`}
                  className="text-[10px] font-mono font-semibold text-[#5C5F5A] bg-[#F4F1ED] border border-[#EAE7E1] h-5 px-1.5 rounded inline-flex items-center gap-1"
                  title={`Estratto dalla Foto ${photoIndex + 1}`}
                >
                  Foto {photoIndex + 1}
                </span>
              )}
              <div className="text-sm font-semibold min-w-0 break-words [overflow-wrap:anywhere]">
                {isProduct ? (row.name || "(senza nome)") : (row.product_name || "(senza nome)")}
              </div>
            </div>
            {row.batch && (
              <div className="text-xs text-[#8E918C]">Lotto: <span className="font-mono">{row.batch}</span></div>
            )}
          </div>
        </div>
        <Button
          size="icon"
          variant="ghost"
          onClick={onRemove}
          className="h-7 w-7 text-[#8E918C] hover:text-[#C65D47] hover:bg-[#FCEAE8]"
          title="Rimuovi dalla lista"
        >
          <X size={14} />
        </Button>
      </div>

      {row.__selected && (
        isProduct ? (
          <ProductRowFields row={row} onChange={onChange} intraScanLink={intraScanLink} />
        ) : (
          <SaleRowFields row={row} onChange={onChange} products={products} />
        )
      )}
    </div>
  );
}
